import React from 'react';
import { ConfirmationFinePrint } from 'Features/Payment/PurchaseConfirmation/ConfirmationFinePrint';
import './PurchaseConfirmation.css';

export const PurchaseConfirmation = ({ show = false, ctaText, selectedPlan = {}, handleChange }) => {
  if (show) {
    return (
      <div className="purchaseConfirmation">
        <ConfirmationFinePrint ctaText={ctaText} selectedPlan={selectedPlan} />
        <label htmlFor="autopaymentconfirm" className="paymentConfirmationLabel">
          <input
            type="checkbox"
            name="autopaymentconfirm"
            id="autopaymentconfirm"
            onChange={(e) => handleChange(e.target.checked)}
          />{' '}
          I agree to the automatic renewal provision
        </label>
      </div>
    );
  }
  return null;
};
